<template>
  <vx-card no-shadow>
    <div>
      <a href="#" @click="$emit('changeTab','Profile')">
        <h4 class="title-report font-semibold">Profile</h4>
      </a>
      <p class="text-base font-medium">Update your profile information, personal performance settings and maildrop email aliases</p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','Notifications')">
        <h4 class="title-report font-semibold">Notification Settings</h4>
      </a>
      <p class="text-base font-medium">
        Manage pop-up reminders, email, and in-app notification settings.
      </p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','TextSnippets')">
        <h4 class="title-report font-semibold">Notification List</h4>
      </a>
      <div class="text-base font-medium">
        Your recent notifications
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  data () {
    return {
      comment: true,
      answer: true,
      follow: false,
      news: false,
      product_update: false,
      blog: true
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  }
}
</script>
